// extracted by css-extract-rspack-plugin
export default {"link":"RQYGjqMl7oBgk3qH","signInDisclaimer":"eJqCbqAnz7Ulnmkm"};